import { defineMessages } from 'react-intl-next';
import type { IntlShape } from 'react-intl-next';

import type { FlagsStateContainer } from '@confluence/flags/entry-points/FlagsStateContainer.ts';
import { CONTENT_HISTORY } from '@confluence/named-routes/entry-points/routes.ts';

const i18n = defineMessages({
	title: {
		id: 'editor-presets.conflicts-resolved-flag.title',
		defaultMessage: 'All conflicts have been resolved',
		description: 'Title for the success flag when all conflicts have been resolved',
	},
	description: {
		id: 'editor-presets.conflicts-resolved-flag.description',
		defaultMessage: 'Your offline edits have been successfully synced.',
		description: 'Description for the success flag when all conflicts have been resolved',
	},
	viewHistoryButton: {
		id: 'editor-presets.conflicts-resolved-flag.view-history-button',
		defaultMessage: 'View version history',
		description: 'Button to view version history after conflicts are resolved',
	},
});

const FLAG_ID = 'conflicts-resolved-flag';

export const showConflictsResolvedFlag = (
	flags: FlagsStateContainer | undefined,
	intl: IntlShape,
	contentId: string,
	spaceKey: string,
) => {
	if (!flags) {
		return;
	}

	const versionHistoryUrl = CONTENT_HISTORY.toUrl({
		spaceKey,
		contentId,
	});

	void flags.showSuccessFlag({
		id: FLAG_ID,
		title: intl.formatMessage(i18n.title),
		description: intl.formatMessage(i18n.description),
		actions: [
			{
				content: intl.formatMessage(i18n.viewHistoryButton),
				href: versionHistoryUrl,
				onClick: () => {
					hideConflictsResolvedFlag(flags);
				},
			},
		],
	});
};

export const hideConflictsResolvedFlag = (flags: FlagsStateContainer | undefined) => {
	if (!flags) {
		return;
	}

	void flags.hideFlag(FLAG_ID);
};
